export default __webpack_public_path__ + "edfd4b88016553e50e7f53a8139deb90.svg";